<template>
  <div class="select-menu">
    <template v-for="(item, index) in items" :key="index">
      <action-btn
        :to="item.to"
        :title="item.title"
        :icon-src="item.icon"
        :disabled="item.disabled"
        :item="item"
        :loading="loadingIndex === index"
        @click="onItemClick(item, index)"
      >
        <template #item>
          <slot name="item" :item="item" />
        </template>
      </action-btn>
      <div v-if="index !== items.length - 1" class="select-menu__hr" />
    </template>
  </div>
</template>

<script setup lang="ts" generic="T extends SelectMenuItem">
import type { SelectMenuItem } from '@/core/types/components/selectMenu';
import ActionBtn from '@/core/components/buttons/ActionBtn.vue';

defineProps<{
  items: T[];
  loadingIndex?: number | null;
}>();

defineSlots<{
  item?: (props: { item: T | undefined }) => void;
}>();

const emit = defineEmits<{
  (event: 'itemClick', item: T, index: number): void;
}>();

const onItemClick = (item: T, index: number) => {
  emit('itemClick', item, index);
};
</script>

<style scoped lang="scss">
.select-menu {
  width: 100%;

  &__hr {
    width: calc(100% - 32px);
    height: 2px;
    margin: 8px auto;

    background: url('@/assets/img/common/line.png') repeat-x center center / 3px 100%;
  }
}
</style>
